import queryString from "query-string";
export function appendQueryString(url, query) {
  var searchParams = queryString.stringify(query, {
    skipNull: true,
    skipEmptyString: true
  });
  return "".concat(url).concat(url.includes("?") ? "&" : "?").concat(searchParams);
}